let galleryTabs = document.querySelectorAll('.gallery-tabs')

if(galleryTabs.length) {
    for(let tabsWrapper of galleryTabs) {
        let tabs = tabsWrapper.querySelectorAll('.tab')
        let galleries = tabsWrapper.nextElementSibling.querySelectorAll('.gallery-images')

        for(let tab of tabs) {
            tab.addEventListener('click', () => {
                let index = tab.index()

                for(let item of tabs) {
                    item.classList.remove('active')
                }

                tab.classList.add('active')

                for(let item of galleries) {
                    item.classList.remove('active')
                }

                galleries[index].classList.add('active')
            })
        }

        for(let gallery of galleries) {
            let images = gallery.querySelectorAll('.image')
            let options = []
    
            for(let image of images) {
                let img = image.querySelector('img')
                let src = img.getAttribute('src')
                
                options.push({
                    src: src,
                    type: 'image'
                })
        
                image.addEventListener('click', () => {
                    let other = Array.prototype.slice.call( images )
                    let index = other.indexOf(image)
                
                    Fancybox.show(
                        options,
                        {
                            startIndex: index,
                            infinite: false,
                        }
                    )
                })
            }

        }
    }
}